export enum StoryTypeEnum {
  image = 'static',
  video = 'video'
}

export type StoryType = StoryTypeEnum.image | StoryTypeEnum.video;

export type StoryState = 'visible' | 'scheduled' | 'hidden' | 'permanent';
